<template>
	<section class="c-footer">
		<h2 class="accessible-hide">Footer</h2>
		<div class="row">
			<div class="c-footer__info flex-item-2 ">
				<div class="c-footer__info--logo">
					<a href="http://sidearmsports.com/terms-of-service/">
						<img
							src="@/assets/svg/logo_level-next_primary_white.svg"
							alt="LevelNext Logo"
					/></a>
				</div>
				<div class="c-footer__info--copyright">
					<div>
						{{ year }} &#169;
						<span>LevelNext - The College Esports League</span>
					</div>
					<div>
						<ul class="reset-list display-flex">
							<li>
								<a
									href="http://sidearmsports.com/terms-of-service/"
									>Terms of Service</a
								>
							</li>
							<li>
								<a
									href="http://www.sidearmsports.com/privacypolicy/"
									>Privacy Policy</a
								>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div
				class="c-footer__logos display-flex align-items-center flex-item-1 "
			>
				<div class="c-footer__learfield">
					<a
						href="https://www.learfield.com"
						aria-label="Learfield"
						target="_blank"
					>
						<svg
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 200 39"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							aria-labelledby="learfield_logo_title"
						>
							<title id="learfield_logo_title">Learfield</title>
							<g clip-path="url(#clip0)" fill="#fff">
								<path
									d="M56.637 11.185h-2.958V27.73h13.079v-2.913H56.637V11.185zM70.611 27.73h13.08v-2.95H73.57v-3.845h7.2v-2.952h-7.2v-2.37c0-.815-.662-1.475-1.48-1.475h11.6v-2.952H70.611V27.73zm22.343-16.545L87.117 27.73h3.114l4.826-13.593 2.375 6.797h-3.153l-1.051 2.951h5.255l1.362 3.845h3.153L97.16 11.185h-4.205zm26.548 6.835v-3.883a2.954 2.954 0 00-2.959-2.952h-10.12V27.73h2.958v-6.796h4.593l3.153 6.796h3.231l-3.192-6.874a2.876 2.876 0 002.336-2.835zm-2.959-.038h-7.162v-2.37c0-.815-.662-1.475-1.479-1.475h8.641v3.845zm8.603 9.748h2.958v-6.796h7.163v-2.952h-7.163v-2.37c0-.815-.661-1.475-1.479-1.475h11.6v-2.952h-13.079V27.73zm19.852-16.545h-2.958V27.73h2.958V11.185zm5.683 16.545h13.079v-2.95h-10.121v-3.845h7.163v-2.952h-7.163v-2.37c0-.815-.661-1.475-1.479-1.475h11.6v-2.952h-13.079V27.73zm21.254-16.545h-2.959V27.73h13.079v-2.913h-10.12V11.185zm21.954 0h-8.019V27.73h8.019c3.347 0 6.111-2.718 6.111-6.097v-4.389c0-3.34-2.725-6.059-6.111-6.059zm3.153 10.487a3.137 3.137 0 01-3.153 3.145h-5.061v-9.204c0-.816-.661-1.476-1.479-1.476h6.54a3.137 3.137 0 013.153 3.146v4.389zM0 38.954h39.042V0H0v38.954zM16.31 27.73l6.267-6.253 13.39 6.253H16.31zm-.545-16.545h13.819L13 27.73H3.075l14.636-14.603-1.946-1.942z"
								/>
							</g>
							<defs>
								<clipPath id="clip0">
									<path fill="#fff" d="M0 0h200v38.954H0z" />
								</clipPath>
							</defs>
						</svg>
					</a>
				</div>
				<div class="c-footer__sidearm">
					<a
						href="https://www.sidearmsports.com"
						aria-label="Sidearm Sports"
						target="_blank"
					>
						<svg
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 200 57"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							aria-labelledby="sidearm_sports_logo_title"
						>
							<title id="sidearm_sports_logo_title">
								Sidearm Sports Learfield
							</title>
							<g clip-path="url(#clip1)">
								<path
									d="M126.192 3.374c-.61 0-.924.557-.924 1.67v.66c0 .853.61 1.636 1.865 2.366 1.744 1.026 2.894 1.861 3.469 2.505 1.273 1.46 1.9 3.478 1.9 6.053 0 3.617-2.126 5.426-6.362 5.426-2.092 0-3.609-.382-4.515-1.165-.976-.852-1.465-2.296-1.465-4.348v-2.644h5.108c0 .243-.017.609-.052 1.096a16.65 16.65 0 00-.052 1.095c0 1.722.348 2.575 1.045 2.575.698 0 1.029-.661 1.029-1.983 0-.905-.105-1.618-.349-2.122-.244-.505-.732-.992-1.481-1.496-1.953-1.287-3.086-2.104-3.382-2.418-1.221-1.304-1.831-3.096-1.831-5.391 0-3.514 2.005-5.253 5.997-5.253 2.475 0 4.114.522 4.916 1.548.697.87 1.028 2.574 1.028 5.096h-4.881V5.34c0-1.305-.348-1.966-1.063-1.966zm12.621 5.983h.994c.906 0 1.359-.452 1.359-1.339V5.027c0-.888-.453-1.322-1.359-1.322h-.994v5.652zM133.566 0h7.199c3.487 0 5.23 1.687 5.23 5.027V7.74c0 2.4-.645 3.93-1.918 4.626-.819.453-2.58.679-5.264.679v8.992h-5.247V0zm18.949 17.097c0 .922.348 1.392 1.045 1.392.698 0 1.046-.47 1.046-1.392V4.957c0-.922-.348-1.391-1.046-1.391-.697 0-1.045.47-1.045 1.391v12.14zm-5.457-10.54c0-2.226.523-3.879 1.569-4.957C149.673.522 151.329 0 153.56 0c2.249 0 3.888.522 4.934 1.6 1.046 1.061 1.569 2.713 1.569 4.957v8.94c0 2.226-.523 3.879-1.569 4.957-1.046 1.061-2.685 1.6-4.934 1.6-2.231 0-3.887-.539-4.933-1.6-1.046-1.061-1.569-2.713-1.569-4.957v-8.94zm19.577 1.879h.435c1.134 0 1.709-.505 1.709-1.548V5.06c0-1.026-.575-1.548-1.709-1.548h-.435v4.923zM161.388 0h6.031c2.754 0 4.515.383 5.3 1.165.784.783 1.167 2.54 1.167 5.288 0 1.235-.244 2.156-.749 2.765-.506.609-1.377.992-2.598 1.13 1.308.175 2.232.557 2.755 1.149.54.608.802 1.548.802 2.835v7.722h-5.317v-8.366c0-1.27-.488-1.913-1.447-1.913h-.68v10.28h-5.247V0h-.017zm16.525 4.453h-3.381V0h12.446v4.453h-3.382v17.601h-5.683V4.453zm15.759-1.079c-.61 0-.924.557-.924 1.67v.66c0 .853.628 1.636 1.865 2.366 1.744 1.026 2.894 1.861 3.469 2.505 1.273 1.46 1.901 3.478 1.901 6.053 0 3.617-2.11 5.426-6.363 5.426-2.092 0-3.591-.382-4.515-1.165-.959-.852-1.447-2.296-1.447-4.348v-2.644h5.108c0 .243-.018.609-.053 1.096-.034.487-.052.852-.052 1.095 0 1.722.331 2.575 1.029 2.575.697 0 1.046-.661 1.046-1.983 0-.905-.123-1.618-.367-2.122-.226-.505-.732-.992-1.464-1.496-1.97-1.304-3.103-2.122-3.399-2.435-1.22-1.304-1.831-3.096-1.831-5.392 0-3.496 2.005-5.252 6.015-5.252 2.475 0 4.114.521 4.915 1.548.698.87 1.029 2.574 1.029 5.096h-4.898V5.34c.017-1.305-.349-1.966-1.064-1.966z"
									fill="#EE7623"
								/>
								<path
									d="M29.844 3.374c-.645 0-.959.557-.959 1.653v.643c0 .852.645 1.635 1.953 2.366 1.813 1.026 3.015 1.86 3.608 2.504 1.325 1.461 1.97 3.461 1.97 6.035 0 3.6-2.197 5.41-6.607 5.41-2.179 0-3.748-.383-4.69-1.148-1.01-.853-1.516-2.296-1.516-4.349v-2.626h5.317c0 .244-.017.609-.07 1.096-.035.487-.07.852-.07 1.096 0 1.722.367 2.574 1.081 2.574.715 0 1.081-.661 1.081-1.983 0-.904-.122-1.618-.366-2.105-.244-.504-.767-1.008-1.534-1.495-2.057-1.305-3.225-2.105-3.539-2.418-1.272-1.304-1.9-3.096-1.9-5.374C23.603 1.739 25.678 0 29.861 0c2.563 0 4.271.504 5.108 1.53.715.87 1.08 2.557 1.08 5.08h-5.09V5.321c0-1.304-.383-1.948-1.115-1.948zM37.776.07h5.683v21.984h-5.683V.07zM50.78 18.35h.837c.889 0 1.325-.61 1.325-1.81V5.567c0-1.218-.436-1.827-1.325-1.827h-.837v14.61zM45.097.07h7.165c2.249 0 3.835.365 4.759 1.113 1.063.835 1.604 2.348 1.604 4.522v12.14c0 2.818-1.674 4.227-5.038 4.227h-8.49V.07zm20.849 17.549v-4.835h4.811l.54-4.244h-5.35V4.505h5.856L72.361.07h-13.51s1.343.747 1.412 1.948v18.106c-.07 1.182-1.412 1.948-1.412 1.948H69.59l.557-4.436h-4.2v-.017zm13.196-4.87l-.993-8.8-.994 8.8h1.987zM73.982.069h8.176l3.033 21.985h-5.386l-.576-5.93h-2.074l-.627 5.93h-5.335L73.983.07zM90.927 8.47h.435c1.133 0 1.691-.504 1.691-1.548V5.114c0-1.027-.558-1.548-1.69-1.548h-.436V8.47zm-7.13-8.4h7.897c2.736 0 4.497.382 5.281 1.165.785.783 1.168 2.54 1.168 5.27 0 1.235-.244 2.157-.75 2.748-.505.609-1.359.974-2.58 1.13 1.29.157 2.215.54 2.755 1.149.54.59.802 1.547.802 2.835v7.705h-5.317v-7.288c0-1.27-.488-2.035-1.447-2.035h-.68v9.305h-4.148L83.797.07zm15.95 0h7.566l1.482 12.418L110.172.07h7.652v21.984h-4.811V5.722l-2.458 16.332h-3.608l-2.388-16.332v16.332h-4.812V.07zM6.31 17.288l4.707 4.697 6.572-6.557-2.214-2.192-9.065 4.052zM4.445 6.557L6.66 8.766l9.065-4.07L11.017 0 4.445 6.557z"
									fill="#fff"
								/>
								<path
									d="M6.24 10.523l-2.876-2.87L0 10.993l5.23 5.217 10.564-4.748 2.893 2.887 3.347-3.357-5.212-5.2-10.581 4.73z"
									fill="#EE7623"
								/>
								<path
									d="M19.158 44.126h2.075c.366 0 .697.035.993.104.296.07.54.174.75.33.209.157.366.348.488.575.122.226.174.521.174.834 0 .348-.07.644-.192.887a1.56 1.56 0 01-.54.574 2.61 2.61 0 01-.784.313 4.15 4.15 0 01-.96.105h-.87v2.626h-1.134v-6.348zm1.918 2.765c.191 0 .366-.017.523-.035a1.73 1.73 0 00.453-.139.704.704 0 00.314-.278.935.935 0 00.122-.47c0-.19-.035-.33-.122-.452a.703.703 0 00-.314-.278 1.154 1.154 0 00-.436-.122 4.613 4.613 0 00-.506-.035h-.819v1.827h.785v-.018zm4.009.383c0-.505.087-.974.261-1.374.175-.4.401-.765.715-1.044a3.222 3.222 0 011.081-.66 3.846 3.846 0 011.36-.227c.488 0 .959.07 1.377.226.418.157.784.383 1.08.661.314.279.541.626.715 1.044.175.4.262.87.262 1.374 0 .487-.087.939-.262 1.356-.174.4-.4.766-.714 1.061a3.493 3.493 0 01-1.081.696c-.419.174-.872.244-1.377.244a3.85 3.85 0 01-1.36-.244 3.204 3.204 0 01-1.08-.696 3.254 3.254 0 01-.716-1.06 3.365 3.365 0 01-.261-1.357zm1.238 0c0 .348.052.66.157.939.104.278.261.522.453.73a2 2 0 00.697.488c.262.121.558.174.89.174.33 0 .627-.053.888-.174.262-.122.506-.279.697-.487.192-.21.35-.453.454-.731.104-.278.157-.591.157-.94 0-.33-.053-.625-.157-.921a2.202 2.202 0 00-.436-.73 2.01 2.01 0 00-.697-.487 2.19 2.19 0 00-.89-.174c-.313 0-.627.052-.889.174a2.115 2.115 0 00-.68.486 2.202 2.202 0 00-.435.731c-.157.296-.21.591-.21.922zm6.816-3.148h1.237l1.238 4.661h.018l1.394-4.661h1.168l1.377 4.661h.018l1.255-4.661h1.203l-1.866 6.33h-1.098l-1.482-4.748h-.017l-1.482 4.749h-1.098l-1.865-6.331zm10.407 0h4.2v.991h-3.085v1.618h2.912v.956H44.66v1.792h3.243v1.009h-4.376v-6.366h.018zm6.24 0H52c.297 0 .593.035.872.087.279.07.523.174.75.313.226.139.4.33.523.556.139.226.191.522.191.853 0 .452-.122.834-.383 1.13-.262.296-.61.487-1.064.592l1.691 2.817h-1.36l-1.464-2.678h-.82v2.678h-1.132v-6.348h-.018zm2.057 2.73c.157 0 .332-.017.488-.034.157-.018.314-.07.436-.14a.956.956 0 00.314-.278c.087-.122.122-.278.122-.47 0-.173-.035-.313-.122-.417a.865.865 0 00-.296-.26 1.562 1.562 0 00-.401-.14c-.157-.017-.297-.035-.453-.035h-1.029v1.774h.941zm4.359-2.73h4.2v.991h-3.085v1.618h2.911v.956h-2.91v1.792h3.242v1.009h-4.376v-6.366h.018zm6.223 0h2.249c.418 0 .836.052 1.255.156a2.97 2.97 0 011.133.54c.331.243.61.573.82.973.208.4.313.905.313 1.496 0 .557-.105 1.026-.314 1.426-.21.4-.488.73-.82.992-.33.26-.714.452-1.132.574a4.485 4.485 0 01-1.255.191h-2.25v-6.348zm2.074 5.357c.297 0 .593-.035.872-.105.296-.07.558-.19.802-.347a1.64 1.64 0 00.575-.661c.157-.279.227-.644.227-1.061 0-.453-.07-.818-.227-1.113a2.206 2.206 0 00-.575-.679 2.174 2.174 0 00-.802-.33 5.1 5.1 0 00-.872-.087h-.941v4.383h.941zm8.559-5.357h2.476c.244 0 .47.035.715.087.226.052.435.156.627.278.174.122.331.296.453.504.105.21.175.453.175.73 0 .366-.105.662-.314.888-.21.226-.47.4-.802.504v.018c.401.052.732.208.994.47.261.26.383.608.383 1.026 0 .347-.07.643-.209.87-.14.243-.314.417-.54.573-.227.14-.488.244-.767.313-.297.07-.593.087-.89.087h-2.283v-6.348h-.017zm1.134 2.574h1.01c.384 0 .663-.07.855-.226a.785.785 0 00.296-.644c0-.278-.104-.487-.296-.608-.21-.122-.523-.174-.959-.174h-.906V46.7zm0 2.817h1.01c.14 0 .297-.017.471-.034.175-.018.314-.07.471-.122a.919.919 0 00.349-.278.866.866 0 00.14-.505c0-.33-.105-.574-.35-.695-.226-.14-.575-.192-1.028-.192h-1.063v1.826zm6.972-1.808l-2.388-3.583h1.377l1.604 2.66 1.621-2.66h1.308l-2.389 3.583v2.748h-1.133v-2.748zm35.475-4.122h-1.325v7.409h5.858V49.69h-4.533v-6.105zm6.258 7.409h5.857v-1.322h-4.532v-1.722h3.225V46.63h-3.225v-1.06a.661.661 0 00-.662-.662h5.194v-1.322h-5.857v7.41zm10.006-7.409l-2.614 7.409h1.394l2.162-6.088 1.063 3.044h-1.412l-.471 1.322h2.354l.61 1.722h1.412l-2.615-7.41h-1.883zm11.889 3.061v-1.74c0-.73-.593-1.322-1.325-1.322h-4.532v7.41h1.325v-3.044h2.057l1.412 3.044h1.447l-1.43-3.079a1.288 1.288 0 001.046-1.27zm-1.325-.018h-3.207v-1.06a.662.662 0 00-.663-.662h3.87v1.722zm3.853 4.366h1.325v-3.044h3.207V46.63h-3.207v-1.06a.662.662 0 00-.663-.662h5.195v-1.322h-5.857v7.41zm8.89-7.409h-1.325v7.409h1.325v-7.41zm2.545 7.409h5.858v-1.322h-4.533v-1.722h3.208V46.63h-3.208v-1.06a.661.661 0 00-.662-.662h5.195v-1.322h-5.858v7.41zm9.518-7.409h-1.324v7.409h5.857V49.69h-4.533v-6.105zm9.832 0h-3.591v7.409h3.591a2.739 2.739 0 002.737-2.73V46.3a2.724 2.724 0 00-2.737-2.713zm1.412 4.696c0 .782-.627 1.408-1.412 1.408h-2.266V45.57a.661.661 0 00-.663-.66h2.929c.785 0 1.412.626 1.412 1.408v1.966zm-88.242 7.739h17.485V38.577H91.275v17.445zm7.304-5.026l2.807-2.8 5.997 2.8h-8.804zm-.244-7.41h6.189l-7.427 7.41h-4.445l6.555-6.54-.872-.87zM200 30.803H0v.713h200v-.713z"
									fill="#fff"
								/>
							</g>
							<defs>
								<clipPath id="clip1">
									<path fill="#fff" d="M0 0h200v56.022H0z" />
								</clipPath>
							</defs>
						</svg>
					</a>
				</div>
			</div>
			<div class="c-footer__logos--copyright">
				<div>
					{{ year }} &#169;
					<span>LevelNext - The College Esports League</span>
				</div>
				<div>
					<ul class="reset-list display-flex">
						<li>
							<a href="http://sidearmsports.com/terms-of-service/"
								>Terms of Service</a
							>
						</li>
						<li>
							<a
								href="http://www.sidearmsports.com/privacypolicy/"
								>Privacy Policy</a
							>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'MainFooter',
	components: {},
	data: function() {
		return {
			year: new Date().getFullYear(),
		};
	},
	computed: {},
	mounted() {},
};
</script>

<style scoped lang="scss">
.c-footer {
	background: #000;
	padding: 72px 24px 70px 24px;
	font-size: 1rem;
	font-style: normal;
	letter-spacing: normal;
	line-height: 1.5rem;
	text-align: left;
	color: #e8e8e8;
	position: relative;
	&__info {
		&--logo {
			max-width: 164px;
			margin-bottom: 24px;
		}
		&--copyright {
			a {
				display: flex;
				align-items: center;
				color: #fff;
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
			li {
				&:first-child {
					a {
						&:after {
							content: '';
							display: block;
							height: 25px;
							width: 2px;
							background: #222120;
							margin: 0 12px;
						}
					}
				}
				// &:nth-child(2) {
				// 	a {
				// 		&:after {
				// 			content: '';
				// 			display: block;
				// 			height: 25px;
				// 			width: 2px;
				// 			background: #222120;
				// 			margin: 0 12px;
				// 		}
				// 	}
				// }
			}

			> div {
				margin-bottom: 6px;
				&:first-child {
					font-weight: 700;
				}
			}
		}
	}
	&:before {
		content: '';
		display: block;
		height: 2px;
		width: 100%;
		background: linear-gradient(
			90deg,
			#000000 0%,
			#cc0000 51.56%,
			#000000 100%
		);
		position: absolute;
		top: 0;
		left: 0;
	}
	&__learfield {
		padding: 6px 48px;
		flex: 0 0 auto;
		-webkit-flex: 0 0 auto;
		svg {
			height: 30px;
			width: auto;
			max-height: none;
		}
	}
	&__sidearm {
		padding: 6px 48px;
		padding-right: 0;
		flex: 0 0 auto;
		-webkit-flex: 0 0 auto;
		border-left: solid 1px;
		border-left-color: #222120;
		svg {
			height: 48px;
			width: auto;
			max-height: none;
		}
	}
	&__logos {
		&--copyright {
			display: none;
		}
	}
	@media screen and (max-width: 880px) {
		padding: 0;
		.row {
			flex-wrap: wrap;
		}
		&__info {
			flex: 1 1 100%;
			padding: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			&--copyright {
				display: none;
			}
			&--logo {
				margin: 0;
			}
		}
		&__logos {
			box-shadow: inset 0 0.063rem 0 #222120;
			background-color: #000000;
			> div {
				flex: 1 1 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 48px 24px;
			}
			&--copyright {
				display: block;
				width: 100%;
				> div {
					padding: 12px 24px;
					box-shadow: inset 0 0.063rem 0 #222120;
					&:nth-child(2) {
						box-shadow: none;
						padding: 0;
					}
					> ul {
						display: block !important;
						li {
							padding: 12px 24px;
							box-shadow: inset 0 0.063rem 0 #222120;
							a {
								color: #fff;
								text-decoration: none;
								&:hover {
									text-decoration: underline;
								}
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 540px) {
		&__logos {
			flex-wrap: wrap;
			> div {
				flex: 1 1 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 48px 24px;
				border: none;
				&:first-child {
					border-bottom: 1px solid #222120;
				}
			}
		}
	}
}
</style>
